import type { Hono } from 'hono';
import { hc } from 'hono/client';
import type { KyInstance } from 'ky';

// Wraps a ky client (should include a bearer token hook) as the `fetch` implementation for a
// Hono RPC client, so callers get typed, authenticated requests against `basePath`.
export const createHonoRpcClient =
  <Routes extends Hono>(basePath: string) =>
  ({ prefixUrl = '', client }: { prefixUrl?: string; client: KyInstance }) =>
    hc<Routes>(basePath, {
      fetch: (input: RequestInfo | URL, requestInit?: RequestInit) =>
        client(`${prefixUrl}${input}`, {
          method: requestInit?.method,
          headers: {
            'content-type': 'application/json',
            ...requestInit?.headers,
          },
          body: requestInit?.body,
        }),
    });
